<template>
  <v-dialog v-model="visible" max-width="100%">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">Plan Pago Universidad</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col cols="12" lg="6" class="pa-0">
            <ListadoItem nombreCampo="Nombre Plan" :valorCampo="item.nombre" />
          </v-col>

          <v-col cols="12" lg="6" class="pa-0">
            <ListadoItem nombreCampo="Universidad" :valorCampo="item.universidad?.nombre" />
          </v-col>

          <v-col cols="12">
            <ListadoPlanesPagosConceptosUniversidades
              ref="listadoRef"
              :cargando="false"
              :filasArrastrables="false"
              :items="item.planesPagosConceptosUniversidades" />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ListadoItem from './ListadoItem.vue';
import ListadoPlanesPagosConceptosUniversidades from './ListadoPlanesPagosConceptosUniversidades.vue';

export default {
  name: 'ModalMostrarPlanPagoUniversidad',
  components: {
    ListadoItem,
    ListadoPlanesPagosConceptosUniversidades,
  },
  data() {
    return {
      visible: false,
      item: this.generarObjetoFormRegistrar(),
      nombreItem: 'Plan Pago Universidad',
    };
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
      };
    },
    generarObjetoFormEditar(data) {
      return data;
    },
    abrir(data = null) {
      this.item = this.generarObjetoFormEditar(data);
      this.visible = true;
    },
    cerrar() {
      this.visible = false;
    },
    cerrarActualizar() {
      this.cerrar();
      this.$emit('actualizarListado');
    },
  },
};
</script>